export enum UserOrganizerUpdateStatusEnum {
    NOT_EXISTING = 'NOT_EXISTING',
    OK = 'OK',
}
